import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { UrlConnectionEnum } from "src/app/enums/connection/url-connection.enum";
import { ModelLocatorService } from "../config/model-locator.service";
import { HttpService } from "../http-service/http.service";

@Injectable()
export class ProfileService {

    constructor(private httpService: HttpService,
        private modelLocator: ModelLocatorService) {

    }

    /**
     * Gets all data profile
     * @author Starley Cazorla
     * @returns
     */
    async getAllDataProfile() {
        const config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_PROFILE, { "cpf": this.modelLocator.dadosLogin.cpf }, config));
    }

    /**
     * Updates password
     * @author Starley Cazorla
     * @param newPwd
     * @returns
     */
    async updatePassword(newPwd: string) {
        const config = this.httpService.setHeaderConfig(true);
        let body = {
            cpf: this.modelLocator.dadosLogin.cpf,
            senha: newPwd
        };

        return lastValueFrom(this.httpService.post(UrlConnectionEnum.UPDATE_PROFILE_PWD, body, config));
    }

    /**
     * Updates profile
     * @author Starley Cazorla
     * @param updateData
     * @returns
     */
    async updateProfile(updateData: any) {
        const config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.post(UrlConnectionEnum.UPDATE_PROFILE, updateData, config));
    }

    /**
     * Deletes profile
     * @author Starley Cazorla
     * @returns
     */
    async deleteProfile() {
        const config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.get(UrlConnectionEnum.DELETE_PROFILE, { "cpf": this.modelLocator.dadosLogin.cpf }, config))
    }

}
